module.exports = __webpack_public_path__ + "img/HZ-P1293.2a522388.png";